import ProductStatics from '../../../../_statics/product.statics.json';
import type { ProductType } from '../../../../../types/products';

// product.statics.json is the canonical product display-name table. PRODUCT_SCHEMAS
// is the product-selector card catalog: its `productName` is card copy, and products
// with no card carry a 'Not Available' placeholder.
export const getProductLabel = (product: ProductType): string =>
  ProductStatics.ProductTypes[product]?.full || product;

/**
 * Is this quote made of parts?
 *
 * `componentGlobals` holds one entry per part and is what the part headers
 * render from, so it is the one place that decides. Asked here by everyone who
 * needs the answer, rather than restated as a key count.
 */
export const hasParts = (
  componentGlobals: Record<string, unknown> | undefined
): boolean => Object.keys(componentGlobals ?? {}).length > 0;

/**
 * The display name of the part an item belongs to, on a quote made of parts.
 *
 * Membership is decided by `componentGlobals`, the same record the part
 * headers render from, so an item is never named for a part the screen does
 * not show.
 */
export const partLabelFor = (
  componentGlobals: Record<string, unknown> | undefined,
  productType: string | undefined
): string | undefined => {
  if (
    !productType ||
    !hasParts(componentGlobals) ||
    !(productType in componentGlobals)
  ) {
    return undefined;
  }
  return getProductLabel(productType as ProductType);
};
